import { auth } from '../firebase';

const DEVICE_KEY = 'cdmgrid:deviceKey';

/**
 * Stable identity key for votes, ownership, and facilitator rights.
 * Prefers the anonymous-auth uid; falls back to a persistent random
 * per-device key so two students who both type "Sam" never collide
 * even when auth is unavailable.
 */
export function getIdentityKey() {
  if (auth.currentUser?.uid) return auth.currentUser.uid;
  let key = localStorage.getItem(DEVICE_KEY);
  if (!key) {
    key = `dev_${Math.random().toString(36).slice(2, 12)}${Date.now().toString(36)}`;
    localStorage.setItem(DEVICE_KEY, key);
  }
  return key;
}
